import React, { Component } from 'react';
import {Icon, List, Button, Flex, Radio} from 'antd-mobile';
let HEIGHT = document.documentElement.clientHeight * 0.25;
let data = [
  {
    label: '后备种猪',
    value: 'G',
    check: false
  },
  {
    label: '断奶种猪',
    value: 'W',
    check: false
  },
  {
    label: '流产',
    value: 'A',
    check: false
  }
];
export default class Types extends Component {
  constructor (props) {
    super(props);
    this.state = {
      value: ''
    }
  }
  ok = () => {
    const {value} = this.state;
    typeof this.props.onConfirm === 'function' && this.props.onConfirm(value)
  };
  cancel = () => {
    typeof this.props.onCancel === 'function' && this.props.onCancel()
  };
  selectAll = () => {
    const {value} = this.state;
    this.setState({
      value: value === 'ALL' ? 'G': 'ALL' //
    })
  };
  UNSAFE_componentWillMount() {
    const {value} = this.props;
    data.forEach(o => {
      o.check = (value === 'ALL')
    });
    this.setState({value})
  }

  render() {
    const {height} = this.props;
    const {value} = this.state;
    let all = (value === 'ALL');
    return (
      <List>
        <div  style={{height: height || HEIGHT,overflowY:'scroll'}}>
          <List.Item extra={<Icon color="#108EE9"
                                  type={all?'check': ''}
          />}
                     onClick={()=>{this.selectAll()}}
          >
            全部
          </List.Item>
          {
            data.map((o,i) => {
              return <Radio.RadioItem checked={value === o.value || value === 'ALL'}
                                      key={i}
                                      name="status"
                                      onChange={() => this.setState({
                                        value: o.value
                                      })}
              >
                {o.label}
              </Radio.RadioItem>
            })
          }
        </div>

        <div style={{padding: '15px 10px'}}>
          <Flex>
            <Flex.Item>
              <Button onClick={this.cancel}>取消</Button>
            </Flex.Item>
            <Flex.Item>
              <Button onClick={this.ok}
                      type="primary"
              >确定</Button>
            </Flex.Item>
          </Flex>
        </div>

      </List>
    )
  }
}
